import {
  DocumentationPageApproval,
  DocumentationPageSnapshot,
  DocumentationPageV2,
  ElementGroup,
  ElementGroupSnapshot,
} from "@supernova-studio/model";
import * as Y from "yjs";
import { DocumentationHierarchySettings } from "../design-system-content";
import { VersionRoomBaseYDoc } from "./base";

type DocumentationHierarchyTransaction = {
  pages?: DocumentationPageV2[];
  pageIdsToDelete?: string[];

  groups?: ElementGroup[];
  groupIdsToDelete?: string[];

  pageSnapshots?: DocumentationPageSnapshot[];
  pageSnapshotIdsToDelete?: string[];

  groupSnapshots?: ElementGroupSnapshot[];
  groupSnapshotIdsToDelete?: string[];

  internalSettings?: Partial<DocumentationHierarchySettings>;

  pageHashesToUpdate?: Record<string, string>;

  pageApprovals?: DocumentationPageApproval[];
  pageApprovalIdsToDelete?: string[];

  executedTransactionIds?: string[];
};

export class BackendVersionRoomYDoc {
  private readonly yDoc: Y.Doc;

  constructor(yDoc: Y.Doc) {
    this.yDoc = yDoc;
  }

  updateDocumentationHierarchy(transaction: DocumentationHierarchyTransaction) {
    this.yDoc.transact(trx => {
      const yDoc = new VersionRoomBaseYDoc(trx.doc);

      // Pages
      transaction.pageIdsToDelete && yDoc.deletePages(transaction.pageIdsToDelete);
      transaction.pages && yDoc.updatePages(transaction.pages);

      // Groups
      transaction.groupIdsToDelete && yDoc.deleteGroups(transaction.groupIdsToDelete);
      transaction.groups && yDoc.updateGroups(transaction.groups);

      // Page snapshots
      transaction.pageSnapshotIdsToDelete && yDoc.deletePageSnapshots(transaction.pageSnapshotIdsToDelete);
      transaction.pageSnapshots && yDoc.updatePageSnapshots(transaction.pageSnapshots);

      // Snapshots - published groups
      transaction.groupSnapshotIdsToDelete && yDoc.deleteGroupSnapshots(transaction.groupSnapshotIdsToDelete);
      transaction.groupSnapshots && yDoc.updateGroupSnapshots(transaction.groupSnapshots);

      // Settings
      transaction.internalSettings && yDoc.updateDocumentationInternalSettings(transaction.internalSettings);
      transaction.pageHashesToUpdate && yDoc.updateDocumentationPageContentHashes(transaction.pageHashesToUpdate);
      transaction.pageApprovals && yDoc.updateApprovalStates(transaction.pageApprovals);
      transaction.pageApprovalIdsToDelete && yDoc.removeApprovalStates(transaction.pageApprovalIdsToDelete);

      // Executed transaction ids
      transaction.executedTransactionIds && yDoc.updateExecutedTransactionIds(transaction.executedTransactionIds);
    });
  }

  getDocumentationPageContentHashes() {
    const versionDoc = new VersionRoomBaseYDoc(this.yDoc);

    // Limit each hash string by 100 characters
    const validHashes = Object.entries(versionDoc.getDocumentationPageContentHashes()).filter(e => {
      return e[1].length < 100;
    });

    return Object.fromEntries(validHashes);
  }
}
